import React, { FC } from 'react';
import styles from './title.module.scss';

type Props = {
  icons: React.ReactNode;
};

export const EntitiesCardTitle: FC<Props> = ({ icons, children }) => (
  <div className={styles.container}>
    <div className={styles.iconWrapper}>{icons}</div>
    {children}
  </div>
);
